import React from 'react';
export function PicIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.135 2.892a2.982 2.982 0 00-2.12-.88l-14-.022a3 3 0 00-3 3l-.02 14a3 3 0 003 3l14 .021a3 3 0 003-3l.02-14a2.98 2.98 0 00-.88-2.119zm-1.145 16.12a1 1 0 01-1 1l-14-.02a1 1 0 01-1-1l.02-14a1 1 0 011-1l14 .02a1 1 0 011 1l-.02 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.613 11.843a1.002 1.002 0 00-.8-.4 1 1 0 00-.8.4l-2.689 3.573-1.994-2a1 1 0 00-1.414 0L5.1 16.22a1 1 0 001.412 1.416l2.109-2.1 2.1 2.11a1.014 1.014 0 00.778.29 1 1 0 00.729-.4l2.581-3.43 2.569 3.437a1 1 0 001.6-1.2l-3.365-4.5zM8 9.994a2 2 0 100-4 2 2 0 100 4z"
  }));
}